import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { Availability } from "../../Resources/components/Availability";
import { useNavigate } from "react-router-dom";
import vectorIcon from "./../../../assets/_VectorIcon_.svg";
import { getDefaultAvailabilityById } from "../../../services/api/defaultAvailability/defaultAvailability";
import { IAvailabilities } from "../../../@types/resource.type";
import { FeatureStatic } from "../../../@types/statics/feature.static";
import usePermission from "../../../hooks/usePermission";
import { ModalAvailability } from "../../Resources/components/ModalAvailability";
import { IDefaultAvailabilityType } from "../../../@types/default-availability.type";
import { DefaultAvailabilityStatic } from "../../../@types/statics/default-availability.static";
import styles from "./styles.module.scss";

export const Availabilities: React.FC = () => {
  const [defaultAvailability, setDefaultAvailability] =
    useState<IDefaultAvailabilityType | null>(null);
  const [availabilities, setAvailabilities] = useState<IAvailabilities[]>([]);
  const [weekHours, setWeekHours] = useState<number>(0);
  const permissions = usePermission(FeatureStatic.availabilities.id);
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => {
    setOpenModal(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    const fetchAvailabilities = async () => {
      try {
        const response = await getDefaultAvailabilityById(
          DefaultAvailabilityStatic.default.id
        );
        setDefaultAvailability(response);
        setAvailabilities(response.availabilities);
        setWeekHours(response.weekHours);
      } catch (error) {
        console.error("Erro ao buscar disponibilidade padrão:", error);
      }
    };

    if (!permissions.canView()) {
      navigate("/unauthorized");
    }

    fetchAvailabilities();
  }, [openModal]);

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.configurationsStyle}>
        <div className={styles.back}>
          <Button
            className={styles.buttonMui}
            onClick={() => navigate("/configurations")}
          >
            {vectorIcon && <img src={vectorIcon} />}
            Voltar a tela anterior
          </Button>
        </div>
        <div className={styles.titleAndBtnCreate}>
          <h1>Disponibilidade Padrão</h1>
        </div>
        <div className={styles.container}>
          <div>
            {availabilities.length !== 0 && (
              <Availability
                isClickable={true}
                availabilities={availabilities}
                weekHours={weekHours}
                onOpenModal={handleOpen}
              />
            )}
          </div>
          {/* <div>
              {availabilities.length !== 0 && (
                <Paper
                  className={styles.paper}
                  elevation={3}
                >
                  <div className={styles.textPaper}>Aplique a Disponibilidade Padrão</div>
                  <div className={styles.centeredDiv}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        className={styles.btnConfigure}
                        onClick={handleClickButton}
                      >
                        Todos Colaboradores
                      </Button>
                    </div>
                </Paper>
                )}
              </div> */}
        </div>
      </div>
      <ModalAvailability
        open={openModal}
        handleClose={handleClose}
        defaultAvailabilityData={defaultAvailability}
        setAvailabilities={setAvailabilities}
        setWeekHours={setWeekHours}
      />
    </>
  );
};
